exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-0a0d6875] tbody td{\n    cursor: pointer;\n}\n[data-v-0a0d6875] tbody td td.non-clickable{\n    cursor: auto;\n}\n", ""]);

// exports
